import React from 'react'

import {
  Body2,
  BorderStyle,
  Box,
  Color,
  Display,
  JustifyContent,
  Space,
  Stars,
} from '@gousto-internal/citrus-react'

export type TestimonialCardProps = {
  quote: string
  author: string
}

export function TestimonialCard({ quote, author }: TestimonialCardProps) {
  return (
    <Box
      paddingV={6}
      paddingH={6}
      borderWidth={0.5}
      borderRadius={1.5}
      borderStyle={BorderStyle.Solid}
      borderColor={Color.ColdGrey_100}
    >
      <Box display={Display.Flex} justifyContent={JustifyContent.FlexStart} paddingBottom={4}>
        <Stars rating={5} />
      </Box>

      <Body2 size={4}>{quote}</Body2>
      <Space size={3} />
      <Body2 size={4}>{author}</Body2>
    </Box>
  )
}
